export const GROUP_COURSE_THRESHOLD = 6;
export const LARGE_GROUP_COURSE_THRESHOLD = 10;

type ParticipantLike = {
  name?: string | null;
};

type CourseWithParticipants = {
  teilnehmer?: string | null;
  participants?: ParticipantLike[] | null;
};

function splitParticipantText(raw: string): string[] {
  return raw
    .split(/[,\n;/]+/)
    .map((part) => part.trim())
    .filter(Boolean);
}

export function getParticipantNames(course: CourseWithParticipants): string[] {
  const structured = Array.isArray(course.participants)
    ? course.participants
        .map((p) => (p?.name || '').trim())
        .filter(Boolean)
    : [];
  if (structured.length > 0) return structured;

  const fallback = (course.teilnehmer || '').trim();
  if (!fallback) return [];
  return splitParticipantText(fallback);
}

export function getParticipantCount(course: CourseWithParticipants): number {
  return getParticipantNames(course).length;
}

export function getGroupSizeBucket(participantCount: number): 'single' | 'smallGroup' | 'group' | 'largeGroup' {
  if (participantCount >= LARGE_GROUP_COURSE_THRESHOLD) return 'largeGroup';
  if (participantCount >= GROUP_COURSE_THRESHOLD) return 'group';
  if (participantCount >= 2) return 'smallGroup';
  return 'single';
}

export function formatParticipantPreview(names: string[], visibleLimit: number): { preview: string; hiddenCount: number } {
  if (names.length === 0) return { preview: '', hiddenCount: 0 };
  const visible = names.slice(0, visibleLimit);
  const hiddenCount = Math.max(0, names.length - visible.length);
  const preview = visible.join(', ');
  return { preview, hiddenCount };
}
